import CustomToolTip from "./CustomToolTip";

export default CustomToolTip;
